import { coinGeckoCall } from './coingecko-support'
import { callSubgraphPrices } from './subgraph-supports'
import { GraphQLClient } from 'graphql-request'
import { cachedClient } from '../subgraph/graph-client'
import { Wei } from '../../utils/types'
import { Token } from '../../logic/token/token'
import { fromWei } from '../../utils/static-web3'
import { Amounts } from '../../logic/token/amounts'

export interface PriceQueryResult {
  price: number
  symbol: string
}

let lastPrices: PriceQueryResult[] | undefined = undefined
export let priceBroker = 'CoinGecko'

export interface PriceOracle {
  // TODO: should be renamed as loadPrices
  getPrices: () => Promise<PriceQueryResult[]>
  getPrice: (symbol: string) => number
  getAmountPrice: (token: Token, amount: Wei) => number
  calculateBag(amounts: Amounts): number
}

export const oracleApi: PriceOracle = {
  getPrices: async function (): Promise<PriceQueryResult[]> {
    try {
      const result = await Promise.race([coinGeckoCall(), fallbackResolver()])
      if (result) {
        lastPrices = result
        priceBroker = 'CoinGecko'
      } else {
        await fallback()
      }
    } catch (e: any) {
      await fallback()
    }
    return lastPrices!
  },

  getPrice: function (symbol: string): number {
    if (!lastPrices) {
      throw 'getPrices() oracle ask was not called before'
    }
    return lastPrices!.find(
      p => p.symbol.toUpperCase() === symbol.toUpperCase()
    )!.price
  },

  getAmountPrice: function (token: Token, amount: Wei): number {
    return this.getPrice(token.symbol) * fromWei(amount, token.decimals)
  },

  calculateBag(amounts: Amounts): number {
    let val = 0
    Array.from(amounts.entries()).forEach(
      ([token, amount]) =>
        (val +=
          oracleApi.getPrice(token.symbol) * fromWei(amount, token.decimals))
    )
    return val
  },
}

/* Handling fallback */
const fallbackTimeoutLimit = 500
const fallbackResolver = (): Promise<undefined> => {
  return new Promise(resolve =>
    setTimeout(resolve, fallbackTimeoutLimit, undefined)
  )
}

async function fallback() {
  console.warn('Using Chainlink fallback api for prices')
  const fallbackClient: GraphQLClient = cachedClient
  lastPrices = await callSubgraphPrices(fallbackClient)
  priceBroker = 'ChainLink'
}
